<div class="tp-host">
  @if (cell()) {
    <button
      class="tp-trigger-cell mis-cell-field"
      type="button"
      aria-haspopup="dialog"
      [attr.aria-expanded]="open()"
      [attr.aria-label]="ariaLabel() + ' ' + displayTime()"
      [attr.title]="displayTime()"
      (click)="toggle()"
    >
      <i class="ri-time-line tp-trigger-cell__icon" aria-hidden="true"></i>
      <span class="tp-trigger-cell__value">{{ displayTime() }}</span>
    </button>
  } @else {
    <button
      class="tp-trigger"
      type="button"
      aria-haspopup="dialog"
      [attr.aria-expanded]="open()"
      [attr.aria-label]="ariaLabel() + ' ' + displayTime()"
      (click)="toggle()"
    >
      <i class="ri-time-line text-sm" aria-hidden="true"></i>
      {{ displayTime() }}
    </button>
  }
</div>

<ng-template #dropdownTpl>
  <div
    class="tp-dropdown"
    role="dialog"
    [attr.aria-label]="ariaLabel()"
    [style.top.px]="dropdownTop() ?? null"
    [style.bottom.px]="dropdownBottom() ?? null"
    [style.left.px]="dropdownLeft() ?? null"
  >
    <div class="tp-spinners" [class.tp-spinners--hour-only]="hourOnly()">
      <div class="tp-spinner">
        <button
          type="button"
          class="tp-step"
          tabindex="-1"
          aria-label="Přidat hodinu"
          [disabled]="!canIncreaseHour()"
          (click)="changeHour(1)"
        >
          <i class="ri-arrow-up-s-line" aria-hidden="true"></i>
        </button>
        <input
          #hourInput
          class="tp-digit tp-digit--hour"
          type="text"
          inputmode="numeric"
          autocomplete="off"
          maxlength="2"
          aria-label="Hodiny"
          [value]="hourDraft()"
          (focus)="onFieldFocus('hour', $event)"
          (input)="onHourInput($event)"
          (keydown)="onHourKeydown($event)"
          (blur)="commitHour()"
        />
        <button
          type="button"
          class="tp-step"
          tabindex="-1"
          aria-label="Odečíst hodinu"
          [disabled]="!canDecreaseHour()"
          (click)="changeHour(-1)"
        >
          <i class="ri-arrow-down-s-line" aria-hidden="true"></i>
        </button>
      </div>

      <span class="tp-colon" aria-hidden="true">:</span>

      @if (hourOnly()) {
        <div class="tp-spinner tp-spinner--static">
          <span class="tp-digit tp-digit--static" aria-hidden="true">00</span>
        </div>
      } @else {
        <div class="tp-spinner">
          <button
            type="button"
            class="tp-step"
            tabindex="-1"
            aria-label="Přidat minutu"
            [disabled]="!canIncreaseMinute()"
            (click)="changeMinute(1)"
          >
            <i class="ri-arrow-up-s-line" aria-hidden="true"></i>
          </button>
          <input
            #minuteInput
            class="tp-digit tp-digit--minute"
            type="text"
            inputmode="numeric"
            autocomplete="off"
            maxlength="2"
            aria-label="Minuty"
            [value]="minuteDraft()"
            (focus)="onFieldFocus('minute', $event)"
            (input)="onMinuteInput($event)"
            (keydown)="onMinuteKeydown($event)"
            (blur)="commitMinute()"
          />
          <button
            type="button"
            class="tp-step"
            tabindex="-1"
            aria-label="Odečíst minutu"
            [disabled]="!canDecreaseMinute()"
            (click)="changeMinute(-1)"
          >
            <i class="ri-arrow-down-s-line" aria-hidden="true"></i>
          </button>
        </div>
      }
    </div>

    <div class="tp-footer">
      <button type="button" class="tp-now-btn" (click)="goNow()">Teď</button>
      <button type="button" class="tp-confirm-btn" (click)="confirm()">
        Potvrdit
      </button>
    </div>
  </div>
</ng-template>
